var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M6.2 9.4L2 5.294 6 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeftArrow);
export default __webpack_public_path__ + "static/media/icon-left-arrow.0229be0f5e1684889e733d6a96b6e486.svg";
export { ForwardRef as ReactComponent };